import React from "react";
import { Clock, LogOut, RefreshCw } from "lucide-react";

interface SessionTimeoutModalProps {
    isOpen: boolean;
    remainingSeconds: number;
    onStaySignedIn: () => void;
    onLogout: () => void;
}

export const SessionTimeout = ({
                                 isOpen,
                                 remainingSeconds,
                                 onStaySignedIn,
                                 onLogout,
                             }: SessionTimeoutModalProps) => {

    if (!isOpen) return null;

    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;

    const formattedTime =
        `${minutes.toString().padStart(2, "0")}:` +
        `${seconds.toString().padStart(2, "0")}`;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">

            <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden">

                {/* Header */}
                <div className="bg-slate-900 px-6 py-5 text-white">
                    <div className="flex items-center gap-3">

                        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10">
                            <Clock size={24} />
                        </div>

                        <div>
                            <h2 className="text-lg font-bold">
                                Session Expiring
                            </h2>

                            <p className="text-sm text-slate-300">
                                Your session is about to end
                            </p>
                        </div>

                    </div>
                </div>

                {/* Content */}
                <div className="p-6">

                    <div className="text-center">

                        <p className="text-sm text-slate-600">
                            You will be automatically signed out in
                        </p>

                        <div className="my-4 text-5xl font-bold text-red-600 tabular-nums">
                            {formattedTime}
                        </div>

                        <p className="text-sm text-slate-500">
                            Would you like to continue your work session?
                        </p>

                    </div>

                    {/* Buttons */}
                    <div className="mt-6 grid grid-cols-2 gap-3">

                        <button
                            type="button"
                            onClick={onLogout}
                            className="
                                flex items-center justify-center gap-2
                                rounded-xl
                                border border-slate-300
                                bg-white
                                px-4 py-3
                                font-semibold
                                text-slate-700
                                transition
                                hover:bg-slate-100
                                active:scale-[0.98]
                            "
                        >
                            <LogOut size={18} />

                            Sign Out
                        </button>

                        <button
                            type="button"
                            onClick={onStaySignedIn}
                            className="
                                flex items-center justify-center gap-2
                                rounded-xl
                                bg-green-600
                                px-4 py-3
                                font-semibold
                                text-white
                                transition
                                hover:bg-green-700
                                active:scale-[0.98]
                            "
                        >
                            <RefreshCw size={18} />

                            Stay Signed In
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
};
